export default {
  title: 'Upload Data',
  menu: 'Upload Data',
  label: {
    jobId: 'Job Id',
    selectFileWithColon: 'Select File',
    downloadResumeTemplate: 'Download resume template',
    sendingNotification: 'Sending Notification',
    emailOrSMS: 'Email or SMS',
    selectFile: 'Select File',
    noSelectFile: 'No file selected',
    importDataStatus: 'Import Data Status',
    importing: 'Importing...',
    candidate: 'candidate(s)',
    successFinishImport: 'Success finish import',
    failedImport: 'Failed import',
    upload: 'Upload'
  },
  placeholder: {
  },
  message: {
  }
}
